import Social from '../Social'

const Aside = (props) => (
  <aside className='col-12 col-lg-1'>
    <div className='sticky-top sticky-top--offset-lg mc-py-8'>
      <Social {...props} />
    </div>
  </aside>
)

export default Aside
